module.exports = __webpack_public_path__ + "static/media/feedback-disabled-banner.76511bf3.svg";